module.exports = __webpack_public_path__ + "static/media/prospero-night-shot.03bb7ad7.jpg";